import { render, staticRenderFns } from "./IndustryMan.vue?vue&type=template&id=db4b1086&scoped=true&"
import script from "./IndustryMan.vue?vue&type=script&lang=js&"
export * from "./IndustryMan.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "db4b1086",
  null
  
)

export default component.exports